import WaitingRoom from './WaitingRoom.page';

export default WaitingRoom;
